<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
export default {
  emits: ['onAction'],
  mixins: [
    AppNotificacao
  ],
  props: {
    sp: {
      type: Object,
      required: true
    },
    drawnArea: {
      type: Number,
      default: 0
    },
    hasDrawing: Boolean
  },
  data () {
    return {
      ruleForm: {
        vectorizedArea: this.drawnArea
      },
      rules: {
        vectorizedArea: [
          { validator: this.isWithinLimit }
        ]
      },
      isDrawing: false,
      isFormValid: false,
      deleteActive: false
    }
  },
  watch: {
    drawnArea (newVal) {
      this.ruleForm.vectorizedArea = newVal
    }
  },
  methods: {
    isWithinLimit (_, value, callback) {
      const isMrpa = this.sp.id === 'MRPA'
      if (isMrpa) {
        callback()
        this.isFormValid = true
        return
      }
      const { tolerance, area } = this.sp
      const upperLimit = area + (area * tolerance)
      const lowerLimit = area - (area * tolerance)

      const isWithinLimit = value >= lowerLimit && value <= upperLimit
      if (!isWithinLimit) {
        callback(new Error('Fora do limite de tolerância'))
      } else {
        callback()
        this.isFormValid = true
      }
    },
    initDrawing () {
      this.isDrawing = true
      this.deleteActive = false

      this.$emit('onAction', { type: 'initVectorization' })
    },
    deleteDrawing () {
      this.$confirm('Tem certeza que deseja remover? Todos os polígonos dessa prática serão perdidos.', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.isDrawing = false
        this.$refs.ruleForm.resetFields()
        this.isFormValid = false

        this.$emit('onAction', { type: 'deleteVectorization' })
      })
    },
    deleteDrawingPolygon () {
      this.$confirm('Tem certeza que deseja remover este polígono? Essa ação não pode ser desfeita.', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.isDrawing = false
        this.$refs.ruleForm.resetFields()
        this.isFormValid = false

        this.$emit('onAction', { type: 'deleteVectorizationPolygon' })
      })
    },
    importShape () {
      this.$emit('onAction', { type: 'importShape' })
    },
    submitShape () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('onAction', { type: 'submitForm' })
        } else {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'Preencha o campo de área vetorizada'
          )
        }
      })
    },
    backToTable () {
      this.$emit('onAction', { type: 'backToTable' })
    },
    activeDelete () {
      this.isDrawing = false
      this.deleteActive = true
    },
    inactiveDelete () {
      this.deleteActive = false
    }
  }
}
</script>

<template>
  <section class="sedap-vectorization-menu">
    <div class="sedap-vectorization-menu__wrapper">
      <h3 class="sedap-vectorization-menu__title">{{sp.name}}</h3>

      <div class="sedap-vectorization-menu__actions">
        <el-button
          size="medium"
          type="success"
          round
          @click="initDrawing"
          class="w200px"
        >
          <font-awesome-icon icon="pencil-alt" />
          Desenhar polígono
        </el-button>
        <el-button
          size="medium"
          type="text"
          @click="importShape"
          class="w200px"
        >
          <font-awesome-icon icon="upload" />
          Importar shape
        </el-button>
        <el-button
          v-if="hasDrawing && !deleteActive"
          size="medium"
          type="danger"
          round
          @click="activeDelete"
          class="w200px"
        >
          <font-awesome-icon icon="eraser" />
          Apagar polígono
        </el-button>
        <div v-else-if="hasDrawing" class="flex-column justify-center align-center">
          <el-button
            size="medium"
            type="danger"
            round
            @click="inactiveDelete"
            class="w200px"
          >
            <font-awesome-icon icon="eraser" />
            Cancelar
          </el-button>
          <p>Clique no desenho para apagá-lo</p>
        </div>
      </div>

      <div class="sedap-vectorization-menu__form-wrapper">
        <div class="sedap-vectorization-menu__form">
          <p class="sedap-vectorization-menu__declared-area">
            Área declarada: <span>{{sp.area}} ha</span>
          </p>
          <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
            <el-form-item label="Área vetorizada (ha)" prop="vectorizedArea">
              <el-col :span="6">
                <el-input disabled :value="ruleForm.vectorizedArea.toFixed(2)"/>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <div class="sedap-vectorization-menu__footer">
          <el-button size="medium" type="text" @click="backToTable">
            <font-awesome-icon icon="chevron-left" />
            Voltar
          </el-button>
          <el-button
            size="medium"
            type="primary"
            round
            @click="submitShape"
          >
            <font-awesome-icon icon="check" />
            Finalizar edição
          </el-button>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Maps/SustainablePracticesMap/VectorizationMenu/VectorizationMenu.vue